import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config/config';

export const LabelsContext = createContext();

export const LabelsProvider = ({ children }) => {
  const [labels, setLabels] = useState({});

  useEffect(() => {
    const fetchLabels = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}${config.labelsEndpoint}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        });

        // Organize labels by tableName and fieldName
        const labelsMap = response.data.reduce((acc, label) => {
          if (!acc[label.tableName]) {
            acc[label.tableName] = {};
          }
          acc[label.tableName][label.fieldName] = label.label;
          return acc;
        }, {});

        setLabels(labelsMap);
      } catch (error) {
        console.error('Error fetching labels:', error);
      }
    };

    fetchLabels();
  }, []);

  return <LabelsContext.Provider value={labels}>{children}</LabelsContext.Provider>;
};